import { useState } from 'react';
import { useLocation } from 'wouter';
import { apiClient } from '@/lib/api-client';
import { platformService } from '@/services/api/platform.service';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

/**
 * Super-admin (PlatformAdmin) login — a SEPARATE identity from tenant users.
 * On success the platform token becomes the active session; the dashboard follows.
 */
export default function PlatformLoginPage() {
  const [, setLocation] = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { accessToken } = await platformService.login(email.trim(), password);
      apiClient.setPlatformSession(accessToken);
      setLocation('/platform');
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Invalid credentials');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-2 px-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4 rounded-lg bg-surface p-6 shadow">
        <div>
          <h1 className="text-xl font-semibold text-ink">Platform Admin</h1>
          <p className="text-sm text-ink-subtle">Super-admin console sign in</p>
        </div>

        {error && <div className="rounded bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}

        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          required
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
        <Button type="submit" variant="primary" className="w-full" disabled={submitting}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>
    </div>
  );
}
